/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface ValidationProblemDetails
 */
export interface ValidationProblemDetails {
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    title?: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ValidationProblemDetails
     */
    status?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    instance?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationProblemDetails
     */
    errors?: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the ValidationProblemDetails interface.
 */
export function instanceOfValidationProblemDetails(value: object): value is ValidationProblemDetails {
    return true;
}

export function ValidationProblemDetailsFromJSON(json: any): ValidationProblemDetails {
    return ValidationProblemDetailsFromJSONTyped(json, false);
}

export function ValidationProblemDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationProblemDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'status': json['status'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['status']),
        'detail': json['detail'] == null ? undefined : json['detail'],
        'instance': json['instance'] == null ? undefined : json['instance'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ValidationProblemDetailsToJSON(json: any): ValidationProblemDetails {
    return ValidationProblemDetailsToJSONTyped(json, false);
}

export function ValidationProblemDetailsToJSONTyped(value?: ValidationProblemDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
        'status': ActorActivityRecordActorUserIdToJSON(value['status']),
        'detail': value['detail'],
        'instance': value['instance'],
        'errors': value['errors'],
    };
}

